// (function () {
//   // ============================================
//   // Quick Buy Drawer creation
//   // ============================================
//   function createQuickdrawerElement(item) {
//     if (item.querySelector("quick-buy-button")) return;

//     const productTitle =
//       item.querySelector('.card__heading, [class*="title"]')?.textContent?.trim() || "Product";

//     const quickBuyButton = document.createElement("quick-buy-button");
//     quickBuyButton.className = "card__quick-add-btn";
//     quickBuyButton.setAttribute("aria-label", `Quick add: ${productTitle}`);
//     quickBuyButton.innerHTML = `
//       <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M16.4962 4.005C16.3824 3.87727 16.2428 3.77513 16.0866 3.70532C15.9304 3.63551 15.7612 3.59961 15.5902 3.6H11.9962C11.9962 2.64522 11.6169 1.72955 10.9418 1.05442C10.2666 0.379285 9.35095 0 8.39617 0C7.44139 0 6.52572 0.379285 5.85059 1.05442C5.17546 1.72955 4.79617 2.64522 4.79617 3.6H1.20217C1.03212 3.60046 0.864072 3.63676 0.708995 3.70655C0.553918 3.77633 0.415297 3.87803 0.302173 4.005C0.189995 4.1315 0.105814 4.28028 0.0551477 4.44158C0.00448152 4.60289 -0.0115263 4.77308 0.00817329 4.941L1.07767 13.941C1.11236 14.2342 1.25395 14.5044 1.47534 14.6998C1.69674 14.8952 1.9824 15.002 2.27767 15H14.5214C14.8167 15.002 15.1024 14.8952 15.3238 14.6998C15.5451 14.5044 15.6867 14.2342 15.7214 13.941L16.7909 4.941C16.8105 4.77302 16.7944 4.6028 16.7436 4.44149C16.6928 4.28019 16.6085 4.13144 16.4962 4.005ZM8.39617 1.2C9.03269 1.2 9.64314 1.45286 10.0932 1.90294C10.5433 2.35303 10.7962 2.96348 10.7962 3.6H5.99617C5.99617 2.96348 6.24903 2.35303 6.69912 1.90294C7.1492 1.45286 7.75965 1.2 8.39617 1.2ZM14.5282 13.8C14.526 13.8008 14.5236 13.8008 14.5214 13.8H2.26492L1.20217 4.8H15.5962L14.5282 13.8Z" fill="#1E2525"/>
//       </svg>
//     `;

//     const link = item.querySelector(".kmnx-card-img-link");
//     if (!link) return;

//     link.style.position = "relative";

//     const container = document.createElement("div");
//     container.className = "images_variant_container";
//     container.style.position = "relative";
//     container.appendChild(link);
//     item.prepend(container);

//     const href = link.getAttribute("href") || "";
//     const productHandle = href.split("?")[0].split("/products/")[1];

//     const createBuyDrawer = document.createElement("quick-buy-drawer");
//     container.appendChild(quickBuyButton);
//     container.appendChild(createBuyDrawer);

//     if (typeof createBuyDrawer.refreshFromProductJson === "function") {
//       createBuyDrawer.refreshFromProductJson(productHandle);
//     }
//   }

//   // ============================================
//   // Kimonix price formatting ($54 -> $54.00)
//   // ============================================
//   function formatKimonixPrices(root) {
//     root.querySelectorAll('.kmnx-price span').forEach((span) => {
//       const txt = span.textContent.trim();
//       if (!txt || txt.includes('.')) return;
//       const m = txt.match(/^(\D*)(\d[\d,]*)(\D*)$/);
//       if (!m) return;
//       span.textContent = `${m[1]}${m[2]}.00${m[3]}`;
//     });
//   }

//   // ============================================
//   // Combined handler — runs both on a Kimonix card
//   // ============================================
//   function processKimonixCard(card) {
//     createQuickdrawerElement(card);
//     formatKimonixPrices(card);
//   }

//   // ============================================
//   // Single scoped, batched observer
//   // ============================================
//   function watchKimonixElements(durationMs) {
//     const duration = durationMs || 20000;
//     const processed = new WeakSet();
//     const root =
//       document.querySelector('.js-product-list, .product-grid, .collection-listing, main') ||
//       document.body;

//     const process = (card) => {
//       if (processed.has(card)) return;
//       processed.add(card);
//       processKimonixCard(card);
//     };

//     // Already-present cards on load
//     root.querySelectorAll(".kmnx-single-row-card").forEach(process);
//     // Price formatting for the initial full page too (covers non-card price spans)
//     formatKimonixPrices(document);

//     let scheduled = false;
//     const pending = new Set();

//     const flush = () => {
//       scheduled = false;
//       pending.forEach((node) => {
//         if (node.matches?.(".kmnx-single-row-card")) process(node);
//         node.querySelectorAll?.(".kmnx-single-row-card").forEach(process);

//         // Catch price spans that aren't inside a .kmnx-single-row-card
//         if (node.matches?.('.kmnx-price') || node.querySelector?.('.kmnx-price')) {
//           formatKimonixPrices(node);
//         }
//       });
//       pending.clear();
//     };

//     const observer = new MutationObserver((mutations) => {
//       for (const mutation of mutations) {
//         for (const node of mutation.addedNodes) {
//           if (node.nodeType === 1) pending.add(node);
//         }
//       }
//       if (!scheduled && pending.size) {
//         scheduled = true;
//         (window.requestIdleCallback || window.requestAnimationFrame)(flush);
//       }
//     });

//     observer.observe(root, { childList: true, subtree: true });

//     setTimeout(() => observer.disconnect(), duration);
//   }

//   document.addEventListener("DOMContentLoaded", function () {
//     watchKimonixElements();
//   });
// })();

// (function () {
//   // ============================================
//   // Quick Buy Drawer creation
//   // ============================================
//   function createQuickdrawerElement(item) {
//     if (item.querySelector("quick-buy-button")) return;

//     const productTitle =
//       item.querySelector('.card__heading, [class*="title"]')?.textContent?.trim() || "Product";

//     const quickBuyButton = document.createElement("quick-buy-button");
//     quickBuyButton.className = "card__quick-add-btn";
//     quickBuyButton.setAttribute("aria-label", `Quick add: ${productTitle}`);
//     quickBuyButton.innerHTML = `
//       <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M16.4962 4.005C16.3824 3.87727 16.2428 3.77513 16.0866 3.70532C15.9304 3.63551 15.7612 3.59961 15.5902 3.6H11.9962C11.9962 2.64522 11.6169 1.72955 10.9418 1.05442C10.2666 0.379285 9.35095 0 8.39617 0C7.44139 0 6.52572 0.379285 5.85059 1.05442C5.17546 1.72955 4.79617 2.64522 4.79617 3.6H1.20217C1.03212 3.60046 0.864072 3.63676 0.708995 3.70655C0.553918 3.77633 0.415297 3.87803 0.302173 4.005C0.189995 4.1315 0.105814 4.28028 0.0551477 4.44158C0.00448152 4.60289 -0.0115263 4.77308 0.00817329 4.941L1.07767 13.941C1.11236 14.2342 1.25395 14.5044 1.47534 14.6998C1.69674 14.8952 1.9824 15.002 2.27767 15H14.5214C14.8167 15.002 15.1024 14.8952 15.3238 14.6998C15.5451 14.5044 15.6867 14.2342 15.7214 13.941L16.7909 4.941C16.8105 4.77302 16.7944 4.6028 16.7436 4.44149C16.6928 4.28019 16.6085 4.13144 16.4962 4.005ZM8.39617 1.2C9.03269 1.2 9.64314 1.45286 10.0932 1.90294C10.5433 2.35303 10.7962 2.96348 10.7962 3.6H5.99617C5.99617 2.96348 6.24903 2.35303 6.69912 1.90294C7.1492 1.45286 7.75965 1.2 8.39617 1.2ZM14.5282 13.8C14.526 13.8008 14.5236 13.8008 14.5214 13.8H2.26492L1.20217 4.8H15.5962L14.5282 13.8Z" fill="#1E2525"/>
//       </svg>
//     `;

//     const link = item.querySelector(".kmnx-card-img-link");
//     if (!link) return;

//     link.style.position = "relative";

//     const container = document.createElement("div");
//     container.className = "images_variant_container";
//     container.style.position = "relative";
//     container.appendChild(link);
//     item.prepend(container);

//     const href = link.getAttribute("href") || "";
//     const productHandle = href.split("?")[0].split("/products/")[1];

//     const createBuyDrawer = document.createElement("quick-buy-drawer");
//     container.appendChild(quickBuyButton);
//     container.appendChild(createBuyDrawer);

//     if (typeof createBuyDrawer.refreshFromProductJson === "function") {
//       createBuyDrawer.refreshFromProductJson(productHandle);
//     }
//   }

//   // ============================================
//   // Kimonix price formatting ($54 -> $54.00)
//   // ============================================
//   function formatKimonixPrices(root) {
//     root.querySelectorAll('.kmnx-price span').forEach((span) => {
//       const txt = span.textContent.trim();
//       if (!txt || txt.includes('.')) return;
//       const m = txt.match(/^(\D*)(\d[\d,]*)(\D*)$/);
//       if (!m) return;
//       span.textContent = `${m[1]}${m[2]}.00${m[3]}`;
//     });
//   }

//   // ============================================
//   // Combined handler — runs both on a Kimonix card
//   // ============================================
//   function processKimonixCard(card) {
//     createQuickdrawerElement(card);
//     formatKimonixPrices(card);
//   }

//   // ============================================
//   // Single scoped, batched observer
//   // ============================================
//   function watchKimonixElements(durationMs) {
//     const duration = durationMs || 20000;
//     const processed = new WeakSet();
//     const root =
//       document.querySelector('.js-product-list, .product-grid, .collection-listing, main') ||
//       document.body;

//     const process = (card) => {
//       if (processed.has(card)) return;
//       processed.add(card);
//       processKimonixCard(card);
//     };

//     // Already-present cards on load
//     root.querySelectorAll(".kmnx-single-row-card").forEach(process);
//     // Price formatting for the initial full page too (covers non-card price spans)
//     formatKimonixPrices(document);

//     let scheduled = false;
//     const pending = new Set();

//     const flush = () => {
//       scheduled = false;
//       pending.forEach((node) => {
//         if (node.matches?.(".kmnx-single-row-card")) process(node);
//         node.querySelectorAll?.(".kmnx-single-row-card").forEach(process);

//         // Catch price spans that aren't inside a .kmnx-single-row-card
//         if (node.matches?.('.kmnx-price') || node.querySelector?.('.kmnx-price')) {
//           formatKimonixPrices(node);
//         }
//       });
//       pending.clear();
//     };

//     const observer = new MutationObserver((mutations) => {
//       for (const mutation of mutations) {
//         for (const node of mutation.addedNodes) {
//           if (node.nodeType === 1) pending.add(node);
//         }
//       }
//       if (!scheduled && pending.size) {
//         scheduled = true;
//         (window.requestIdleCallback || window.requestAnimationFrame)(flush);
//       }
//     });

//     observer.observe(root, { childList: true, subtree: true });

//     setTimeout(() => observer.disconnect(), duration);
//   }

//   document.addEventListener("DOMContentLoaded", function () {
//     // ✅ Wait 3 seconds before doing any initial card processing or
//     // starting the MutationObserver, so it doesn't fire immediately
//     // on page load.
//     setTimeout(() => {
//       watchKimonixElements();
//     }, 4000);
//   });
// })();

(function () {
  // ============================================
  // Shared constants (created once, not per-call)
  // ============================================
  const QUICK_BUY_SVG = `
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4962 4.005C16.3824 3.87727 16.2428 3.77513 16.0866 3.70532C15.9304 3.63551 15.7612 3.59961 15.5902 3.6H11.9962C11.9962 2.64522 11.6169 1.72955 10.9418 1.05442C10.2666 0.379285 9.35095 0 8.39617 0C7.44139 0 6.52572 0.379285 5.85059 1.05442C5.17546 1.72955 4.79617 2.64522 4.79617 3.6H1.20217C1.03212 3.60046 0.864072 3.63676 0.708995 3.70655C0.553918 3.77633 0.415297 3.87803 0.302173 4.005C0.189995 4.1315 0.105814 4.28028 0.0551477 4.44158C0.00448152 4.60289 -0.0115263 4.77308 0.00817329 4.941L1.07767 13.941C1.11236 14.2342 1.25395 14.5044 1.47534 14.6998C1.69674 14.8952 1.9824 15.002 2.27767 15H14.5214C14.8167 15.002 15.1024 14.8952 15.3238 14.6998C15.5451 14.5044 15.6867 14.2342 15.7214 13.941L16.7909 4.941C16.8105 4.77302 16.7944 4.6028 16.7436 4.44149C16.6928 4.28019 16.6085 4.13144 16.4962 4.005ZM8.39617 1.2C9.03269 1.2 9.64314 1.45286 10.0932 1.90294C10.5433 2.35303 10.7962 2.96348 10.7962 3.6H5.99617C5.99617 2.96348 6.24903 2.35303 6.69912 1.90294C7.1492 1.45286 7.75965 1.2 8.39617 1.2ZM14.5282 13.8C14.526 13.8008 14.5236 13.8008 14.5214 13.8H2.26492L1.20217 4.8H15.5962L14.5282 13.8Z" fill="#1E2525"/>
    </svg>
  `;
  // Compiled once instead of on every price span processed
  const PRICE_RE = /^(\D*)(\d[\d,]*)(\D*)$/;
  const CARD_SELECTOR = ".kmnx-single-row-card";
  const PRICE_SELECTOR = ".kmnx-price span";

  // ============================================
  // Quick Buy Drawer creation
  // ============================================
  function createQuickdrawerElement(item) {
    // Single query instead of two separate ones; also short-circuits fast
    const link = item.querySelector(".kmnx-card-img-link");
    if (!link || item.querySelector("quick-buy-button")) return;

    const productTitle =
      item.querySelector('.card__heading, [class*="title"]')?.textContent?.trim() || "Product";

    const quickBuyButton = document.createElement("quick-buy-button");
    quickBuyButton.className = "card__quick-add-btn";
    quickBuyButton.setAttribute("aria-label", `Quick add: ${productTitle}`);
    // Reuse the same markup string reference instead of rebuilding template literal each call
    quickBuyButton.innerHTML = QUICK_BUY_SVG;

    link.style.position = "relative";

    const container = document.createElement("div");
    container.className = "images_variant_container";
    container.style.position = "relative";

    // Build off-DOM, then do the DOM writes together to minimize reflow/layout thrash
    container.appendChild(link);
    container.appendChild(quickBuyButton);

    const href = link.getAttribute("href") || "";
    const productHandle = href.split("?")[0].split("/products/")[1];

    const createBuyDrawer = document.createElement("quick-buy-drawer");
    container.appendChild(createBuyDrawer);

    item.prepend(container);

    if (typeof createBuyDrawer.refreshFromProductJson === "function") {
      createBuyDrawer.refreshFromProductJson(productHandle);
    }
  }

  // ============================================
  // Kimonix price formatting ($54 -> $54.00)
  // ============================================
  function formatKimonixPrices(root) {
    const spans = root.querySelectorAll(PRICE_SELECTOR);
    // Cache length, avoid forEach closure overhead on large collections
    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];
      const txt = span.textContent.trim();
      if (!txt || txt.indexOf(".") !== -1) continue;
      const m = PRICE_RE.exec(txt);
      if (!m) continue;
      span.textContent = `${m[1]}${m[2]}.00${m[3]}`;
    }
  }

  // ============================================
  // Combined handler — runs both on a Kimonix card
  // ============================================
  function processKimonixCard(card) {
    createQuickdrawerElement(card);
    formatKimonixPrices(card);
  }

  // ============================================
  // Single scoped, batched observer
  // ============================================
  function watchKimonixElements(durationMs) {
    const duration = durationMs || 20000;
    const processed = new WeakSet();
    const root =
      document.querySelector('.js-product-list, .product-grid, .collection-listing, main') ||
      document.body;

    const process = (card) => {
      if (processed.has(card)) return;
      processed.add(card);
      processKimonixCard(card);
    };

    // Already-present cards on load
    root.querySelectorAll(CARD_SELECTOR).forEach(process);
    // Price formatting for the initial full page too (covers non-card price spans)
    formatKimonixPrices(document);

    let scheduled = false;
    const pending = new Set();

    const flush = () => {
      scheduled = false;
      pending.forEach((node) => {
        // Skip disconnected/removed nodes (can happen with fast successive mutations)
        if (!node.isConnected) return;

        if (node.matches?.(CARD_SELECTOR)) {
          process(node);
        } else {
          node.querySelectorAll?.(CARD_SELECTOR).forEach(process);
        }

        // Catch price spans that aren't inside a .kmnx-single-row-card
        // (cards already run formatKimonixPrices via processKimonixCard,
        // so this only does extra work for non-card nodes)
        if (!node.matches?.(CARD_SELECTOR) &&
            (node.matches?.(".kmnx-price") || node.querySelector?.(".kmnx-price"))) {
          formatKimonixPrices(node);
        }
      });
      pending.clear();
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) pending.add(node);
        }
      }
      if (!scheduled && pending.size) {
        scheduled = true;
        (window.requestIdleCallback || window.requestAnimationFrame)(flush);
      }
    });

    observer.observe(root, { childList: true, subtree: true });

    // Store the timer id so it can be cleared if the script is torn down early
    const stopTimer = setTimeout(() => observer.disconnect(), duration);

    return () => {
      clearTimeout(stopTimer);
      observer.disconnect();
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Wait before doing initial processing / starting the observer,
    // so it doesn't fire immediately on page load.
    setTimeout(() => {
      watchKimonixElements();
    }, 4000);
  });
})();